export default "__VITE_ASSET__b991ca69__"